module.exports = __webpack_public_path__ + "static/media/PRUEBA ALGO NUEVO.b2df77dc.jpg";